import { useEffect, useState } from 'react';
import { isDevMode, isCP } from '@utils/app-utils.js';
import { useDispatch, useSelector } from 'react-redux';
import { setUserInfo, setAuthorized } from '@reducers/seller-center/userinfo-slice/index.js';
import { extractJWTPayload } from '@sector-labs/fe-auth-redux/jwt';
import { CableTopHostDriver } from '@sector-labs/cable-widgets';
import keycloak from '../../services/keycloak/index.js';
import { getCurrentUserApi } from '@apis/seller-center/profile-settings.js';
import { isDubizzleTenant, isOLXTenant } from '@utils/utils.js';
import { BASE_PATH, STORE_NOT_FOUND } from '../../constants/seller-center-paths.js';
import { sanitizePathname } from '../../utils/utils.js';

const REFRESH_TIME_GAP = 20000; // Time to refresh before expiry (00:00:20)

const useKeycloak = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.userData);
  const [loading, setLoading] = useState(!isCP());

  // Initializing CABLE_DRIVER instance that is alive for the entire app so that we can keep the user online
  // even when the chat iframe is not loaded.

  const cableDriverUrl = `${process.env.REACT_APP_OLX_PK_KEYCLOACK_AUTH_URL}/widgets/chat`;
  const CABLE_DRIVER = CableTopHostDriver.init(cableDriverUrl);

  // const handleRefreshToken = async (refreshToken) => {
  //   const kc = await keycloak;
  //   if (isDevMode()) {
  //     await kc.updateToken();
  //   } else {
  //     await kc.refresh(refreshToken);
  //     dispatch(
  //       setUserInfo({
  //         ...userInfo,
  //         idToken: kc.idToken,
  //         refreshToken: kc.refreshToken,
  //         accessToken: kc.accessToken,
  //         authenticated: true,
  //         initialized: true,
  //         decodedProfile: extractJWTPayload(kc.idToken),
  //       }),
  //     );
  //   }
  // };

  // useEffect(() => {
  //   if (isOLXTenant()) {
  //     const getTimer = () => {
  //       if (userInfo?.accessToken) {
  //         const expiryTime = userInfo.decodedProfile.exp * 1000;
  //         const now = Date.now();
  //         const delay = expiryTime - now - REFRESH_TIME_GAP;
  //         if (delay > 0) {
  //           const timer = setTimeout(() => {
  //             if (document.visibilityState === 'visible') {
  //               handleRefreshToken(userInfo.refreshToken);
  //             } else {
  //               document.addEventListener('visibilitychange', handleVisibilityChange);
  //             }
  //           }, delay);
  //           window.tokenRefreshTimer = timer;
  //         }
  //       }
  //     };
  //     const handleVisibilityChange = () => {
  //       if (document.visibilityState === 'visible') {
  //         if (userInfo?.accessToken) {
  //           handleRefreshToken(userInfo.refreshToken);
  //           document.removeEventListener('visibilitychange', handleVisibilityChange);
  //         }
  //       }
  //     };
  //     getTimer();
  //     return () => {
  //       document.removeEventListener('visibilitychange', handleVisibilityChange);
  //       if (window.tokenRefreshTimer) {
  //         clearTimeout(window.tokenRefreshTimer);
  //       }
  //     };
  //   }
  // }, [userInfo?.accessToken]);

  useEffect(() => {
    const initKeycloak = async () => {
      const kc = await keycloak;
      try {
        setLoading(true);
        if (isDevMode()) {
          // const authenticated = await kc.init({ onLoad: 'login-required' });
          // if (!authenticated) await kc.login();
          // dispatch(
          //   setUserInfo({
          //     accessToken: kc.token,
          //     authenticated: authenticated,
          //     initialized: true,
          //     idToken: kc.idToken,
          //     refreshToken: kc.refreshToken,
          //     userProfile: extractJWTPayload(kc.idToken),
          //   }),
          // );
          const res = await getCurrentUserApi();
          const currentUser = res?.current_user;
          dispatch(
            setUserInfo({
              authenticated: true,
              initialized: true,
              userProfile: { ...currentUser, image: currentUser?.store?.logo?.sizes?.thumbnail },
              storeId: currentUser?.store?.id,
              admin: res?.admin,
            })
          );
          if (!res?.unauthorized || sanitizePathname(window.location.pathname) === `${BASE_PATH}${STORE_NOT_FOUND}`)
            setLoading(false);
        } else {
          let authenticated = true;
          // if (isOLXTenant()) {
          //   authenticated = await kc.init();
          //   if (!authenticated) await kc.login();
          // }
          if (authenticated) {
            const res = await getCurrentUserApi();
            const currentUser = res?.current_user;
            dispatch(
              setUserInfo({
                authenticated: authenticated,
                initialized: true,
                userProfile: { ...currentUser, image: currentUser?.store?.logo?.sizes?.thumbnail },
                storeId: currentUser?.store?.id,
                admin: res?.admin,
                // ...(isOLXTenant()
                //   ? {
                //       accessToken: kc.accessToken,
                //       idToken: kc.idToken,
                //       refreshToken: kc.refreshToken,
                //       decodedProfile: extractJWTPayload(kc.idToken),
                //     }
                //   : {}),
              })
            );
            // if (!res?.unauthorized || sanitizePathname(window.location.pathname) === `${BASE_PATH}${STORE_NOT_FOUND}`)
            // setLoading(false);
          }
        }
      } catch (e) {
        // if (isDubizzleTenant()) {
        dispatch(setAuthorized(false));
        // }
      } finally {
        // if (isDubizzleTenant()){
        setLoading(false);
        // }
      }
    };

    !isCP() && initKeycloak();
  }, []);

  return { userInfo, CABLE_DRIVER, keycloakLoading: loading };
};

export default useKeycloak;
